export default "__VITE_ASSET__Dp15F8Sn__"